import { AtlasColor } from '@justomx/atlas-components'
import styled, { keyframes } from 'styled-components'

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

export const ModalContainer = styled.div`
  position: fixed;
  background: ${AtlasColor.Background};
  overflow: auto;
  top: 62px;
  left: 0;
  right: 0;
  padding: 16px;
  height: calc(100% - 60px);
  z-index: 1001;
  animation: ${fadeIn} 0.3s ease-in-out;
`
